export const flightConformanceParsedStates = [
    {
        name: 'No Breaches',
        value: 'NO_BREACHES'
    },
    {
        name: 'No Policy',
        value: 'NO_POLICY'
    },
    {
        name: 'Breaches',
        value: 'BREACHES'
    }
];

export const ConformanceStatusGroups = Object.freeze([
    'NO_BREACHES',
    'NO_POLICY',
    'BREACHES'
] as const);

export type ConformanceStatusGroup = typeof ConformanceStatusGroups[number];
